 const ResponseCode = {
    SUCCESS : 0,
    FAIL : -1,
     LOGIN_ERROR : -10,
     BLOCKED : -20,
     DELETE_MEMBER : -30,
     MEMBER_TALK_INVITATION_REJECT : -100,
     SCHEDULE_INVITATION_REJECT : -101,
     PROFILE_HIDDEN : -102,
     NOT_EXIST_DATA : -1000,
     VERSION_CHANGED : -9000,
     NOT_CATCH_ERROR : -9999
}

 export default ResponseCode;